import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { SeoTpa } from './seo-tpa'
import { LifeCycle } from '@wix/thunderbolt-symbols'

export const page: ContainerModuleLoader = (bind) => {
	if (!process.env.browser) {
		bind(LifeCycle.PageWillMountHandler).to(SeoTpa)
	}
}
